/*
 * @Description: 实时定位驾驶舱 — B4「轨迹统计」本地 mock（回放页 4 数据格）
 */
import { TrackStatsData } from '../types/cockpit.types'

/** 单成员当日轨迹统计 mock */
export function getMockTrackStats(): TrackStatsData {
  return {
    totalDistanceMeters: 8400.5,
    totalDurationSec: Math.round(5.2 * 3600),
    pointCount: 1200,
    photoCount: 23,
    startLocation: '104.061,30.578',
    endLocation: '104.072,30.553',
    stayPoints: []
  }
}
